/* eslint-disable no-console */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import NumberFormat from 'react-number-format';
import { Modal } from '@zeeve-platform/modal-component';
import Urls from '../../../utils/urls';
import Protocol from '../protocol';
import { subscriptionItem } from './subscription';
import UpdateSubscription from './updateSubcription';
import questionLogo from '../../../images/question-payment.png';
import apiBackendInstance from '../../../utils/axios';

interface Props {
  index: number,
  item: subscriptionItem,
}
const ServiceCard = ({
  index, item,
}: Props) => {
  const [showAdvance, setShowAdvance] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);
  const [showUnSubscribeModal, setShowUnSubscribeModal] = useState(false);
  const [status, setStatus] = useState(true);
  const [closeStatus, setCloseStatus] = useState(true);
  const [apiResponse, setApiResponse] = useState('');
  const [title, setTitle] = useState('Are you sure you want to unsubscribe ?');

  const showAdvanceTab = (cno: number) => {
    const advanceTab = document.getElementById(`advance-tab-${cno}`);
    if (advanceTab) {
      advanceTab.style.display = 'block';
      setShowAdvance(!showAdvance);
    }
  };

  const hideAdvanceTab = (cno: number) => {
    const advanceTab = document.getElementById(`advance-tab-${cno}`);
    if (advanceTab) {
      advanceTab.style.display = 'none';
      setShowAdvance(!showAdvance);
    }
  };

  const subscribeMore = (data: subscriptionItem, addonCode?: string) => {
    if ('subscribe_more_url' in data && data.subscribe_more_url !== '') {
      window.open(data.subscribe_more_url, '_self');
    } else {
      const nodeType = addonCode?.includes('FULL') ? 'full' : 'validator';
      window.open(Urls.getSelectProtocolUrl(data.protocolType, nodeType, data.frontendBaseSuburl), '_self');
    }
  };

  const isNodeTypeAddon = (addonCode: string) => {
    if (addonCode.includes('FULL') || addonCode.includes('VALIDATOR')) {
      return true;
    }
    return false;
  };

  const addonsArray = item.protocolType === 'public' ? item.subscription_details.addons.filter(({ addon_code }) => isNodeTypeAddon(addon_code)) : item.subscription_details.addons;

  // const updateSubscription = (data: subscriptionItem) => {
  //   if ('update_subscription_url' in data && data.update_subscription_url !== '') {
  //     window.open(data.update_subscription_url, '_self');
  //   } else {
  //     setShowModal(true);
  //   }
  // };

  const removeSubscription = () => {
    setTitle('Status');
    setCloseStatus(false);
    setStatus(false);
    const sendData = {
      subscriptionId: item.subscription_details.subscriptionId,
      plan: { plan_code: item.subscription_details.plan.plan_code, quantity: -item.subscription_details.plan.total_quantity },
      addons: [],
      redirection_url: window.location.href,
    };
    apiBackendInstance.post(Urls.getSubcriptionUpdateUrl(), {
      ...sendData,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response && response.data) {
          setApiResponse(response.data?.data?.message);
          setCloseStatus(true);
        }
      }).catch((err) => {
        console.error(err);
        const errMsg = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Updation failed.';
        setApiResponse(`Error: ${errMsg}`);
      });
  };

  const allowUnSubscribe = () => item.subscription_details.plan.available_quantity === item.subscription_details.plan.total_quantity && !item.subscription_details.plan.plan_code.includes('_RPC_NODES') && !item.subscription_details.plan.plan_code.includes('_ARCHIVE_NODES');

  return (
    <>
      <ul className="nav nav-pills flex-column">
        <div className="d-flex justify-content-left align-items-center">
          <div
            className="col-xl-2 col-lg-3 col-md-3 col-sm-3"
            style={{
              display: 'flex', flexDirection: 'row', justifyContent: 'center',
            }}
          >
            <Protocol name={item.protocol_name} distCount={item.subscription_details.plan.available_quantity} totalCount={item.subscription_details.plan.total_quantity} />
          </div>
          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            {item.subscription_details && item.subscription_details.subscriptionStatus && item.subscription_details.subscriptionStatus === 'trial' ? (
              <b className=""> Free Trial </b>
            ) : (
              <b className="">
                <NumberFormat value={item.subscription_details.amount} displayType="text" decimalScale={2} thousandSeparator prefix="$ " />
              </b>
            )}
          </div>
          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            {
              item.subscription_details.subscriptionStatus && item.subscription_details.subscriptionStatus === 'trial'
                ? (
                  <b className="">-----</b>
                )
                : (
                  <b className="">{item.subscription_details.next_billing_date}</b>
                )
            }
          </div>
          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <b className="">{item.subscription_details.plan.total_quantity}</b>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-2 col-sm-2" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <b className="">{`${item.subscription_details.plan.available_quantity}/ ${item.subscription_details.plan.total_quantity}`}</b>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 px-0" style={{ display: 'flex', width: '250px' }}>
          {item.subscription_details.addons.length > 0 && item.protocolType !== 'public' ? (
<a style={{ textDecoration: 'none' }} onClick={() => subscribeMore(item)}>
              <button type="button" className="px-1 me-2 btn comingSoon" style={{ fontSize: '12px' }}>
                Subscribe More
              </button>
</a>
          ) : null}
            {/* {
              item.subscription_details.subscriptionModifiable
              && item.subscription_details.subscriptionStatus && item.subscription_details.addons.length > 0 && item.subscription_details.subscriptionStatus !== 'trial' && (
                <button type="button" className="px-1 btn comingSoon" style={{ fontSize: '12px' }} onClick={() => updateSubscription(item)}>
                  Update
                </button>
              )
            } */}
            {
              allowUnSubscribe()
              && item.subscription_details.subscriptionModifiable
              && (
                <button type="button" className="mx-2 px-1 btn btn-danger" style={{ fontSize: '12px' }} onClick={() => setShowUnSubscribeModal(true)}>
                  Unsubscribe
                </button>
              )
            }
          </div>
          <div className="col-xl-1 col-sm-2 col-lg-1 col-md-2 cursor" style={{ width: 'fit-content' }}>
            {showAdvance && (
              <i
                className="fa-solid fa-chevron-up mx-3"
                onClick={() => {
                  hideAdvanceTab(index);
                }}
                style={{ fontSize: '15px' }}
              />
            )}
            {!showAdvance && (
              <i
                className="fa-solid fa-chevron-down mx-3"
                onClick={() => {
                  showAdvanceTab(index);
                }}
                style={{ fontSize: '15px', marginTop: '-15px' }}
              />
            )}
          </div>
        </div>

      </ul>
      <ul className="" id={`advance-tab-${index}`} style={{ display: 'none', fontSize: '13px' }}>
        {addonsArray.map((d, idx) => (
          <li key={`lii34tem_${idx.toString()}`}>
            <div className="d-flex mt-2">
              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3">
                <span className="subscriptionSpan" title={d.description}>
                  {d.name}
                  <img className="px-1" src={questionLogo} alt="" />
                </span>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                <span className="mx-5">
                  {d.price === 0
                    && <span>No additional charge</span>}
                  {d.price !== 0 && (
                    <span>
                      {' '}
                      <NumberFormat value={d.price * d.total_quantity} displayType="text" decimalScale={2} thousandSeparator prefix="$ " />
                      {' '}
                      <img className="px-1" src={questionLogo} title={d.costDescription} alt="" />
                      {' '}
                    </span>
                  )}
                </span>
              </div>
              <div className="col-xl-2 col-lg-1 col-md-1 col-sm-1" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }} />
              <div
                className="col-xl-1 col-lg-1 col-md-2 col-sm-2"
                style={{
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '150px',
                }}
              >
                <span className="ms-2">{d.total_quantity}</span>
              </div>
              <div
                className="col-xl-2 col-lg-1 text-center col-md-2 col-sm-2 ms-2"
                style={{
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '130px',
                }}
              >
                <span>{`${d.available_quantity}/ ${d.total_quantity}`}</span>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 text-center" />
              {d.total_quantity > 0 && item.protocolType === 'public' ? (
<a style={{ textDecoration: 'none' }} onClick={() => subscribeMore(item, d.addon_code)}>
              <button type="button" className="px-1 me-2 btn comingSoon" style={{ fontSize: '12px' }}>
                Subscribe More
              </button>
</a>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
      <div className="d-flex">
        <div className="col-12 ">
          <hr className="col-12 hrwidth" />
        </div>
      </div>
      {showModal && <UpdateSubscription data={item} setShowModal={setShowModal} />}
      <Modal
        show={showUnSubscribeModal}
        onHide={() => { apiResponse ? window.location.reload() : setShowUnSubscribeModal(false); }}
        title={title}
        confirmBtnText="Confirm"
        visibleFooterCloseButton={closeStatus}
        visibleFooter={closeStatus}
        visibleConfirmBtn={status}
        visibleHeaderCloseIcon={false}
        onConfirm={() => removeSubscription()}
      >
        <p className="status text-center mt-3" id="modal_status">{apiResponse}</p>
      </Modal>

    </>
  );
};

export default ServiceCard;
